  <div id="planExtension" class="form-step-modal modal fade" *ngIf="event && event.PlanSrc" tabindex={{index}} role="dialog">
    <div class="modal-dialog custum-drop-modal modal-dialog-centered modal-lg" role="document">
      <div class="modal-content form-step-modal__content">

        <div class="modal-body form-crop-modal__body">
          <div style="font-size: 20px;margin-bottom: 10px">
            <img [src]="event.PlanSrc |assetimage" width="100%" height="70%" alt="">
          </div>
          <div class="modal-controls" style="font-size: 20px;margin-bottom: 10px">
            {{event.PlanName}}
          </div>
        </div>
      </div>
    </div>
  </div>


  <app-contact-form-modal  *ngIf="organisaion" [orgaMail]="event.contact_email ? event.contact_email : organisaion.email" #contactFormModal>

  </app-contact-form-modal>


  <div *ngIf="isSecret && event" class="secret secret-background wk-center">
    <div class="col-md-6 secret-border secret-box">
      <h4 style="text-align: center; color: wheat;" *ngIf="unlockPassworderror"> {{'front_event.incorect_password'| translate}} </h4>
      <div class="flex-space-between">
        <h1 class="event-is-secret-fs event-is-secret-txt"> Cet évènement <br> est secret</h1>
        <img src="../../../assets/imgs/trouserrure.png" class="serrure-cone" alt="">
      </div>
      <h6 class="uppercase mt-15p" style="color: white;text-align: left">pour y accéder... veuillez taper le mot de passe</h6>
      <div style="text-align: center; margin-top: 88px;">
        <div style="text-align: center;display: inline-block;width: 100%">
          <h5 style="color: white;text-align: left;color: var(--btn-bgColor);">  {{event.start_date | datefrench1}} </h5>
          <h1 style="color: white;text-align: left">{{event.name}}</h1>

          <h4 style="color: white;text-align: left" *ngIf="!organisaion ">{{'front_event.organizer'| translate}} {{event.user.id}}</h4>
          <h4 style="color: white;text-align: left" *ngIf="organisaion" >Par {{organisaion.name}}</h4>

          <div class="input-group mt-30p">
              <input  [(ngModel)]="password"  type="password" placeholder="MOT DE PASSE" class="form-control password-input-background" id="myPasswordInput">
              <div class="input-group-append">
                <button class="reveal password-button-icon-background" style="cursor: pointer" (click)="showPassword()" type="button"><i *ngIf="secretInputIsPassword" class="fa fa-eye white"></i> <i *ngIf="!secretInputIsPassword" class="fa fa-eye-slash white"></i></button>
              </div>
          </div>

          <div class="row" style="justify-content: space-between;margin-top: 30px">
            <div class="col-md-6 unset-p-lr">
              <button class="secretBtn uppercase col-md-12"  (click)="unlockSecretEvent()"> Accedez à l'événement </button>
            </div>

            <div class="col-md-6 unset-p-lr">
              <button class="mdal1Btn margin-top-20-mini col-md-12 uppercase" (click)="openContactModal()" > Contacter l'organisateur </button>
              <div style="margin-top: 2px"><span style="color: white;font-size: 14px;color: var(--btn-bgColor);">Besoin d'un mot de passe?</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Bannière -->
  <div *ngIf="!isSecret">

  <div  *ngIf="event && pricings" style="clear: both">
    <div *ngIf="checkEventVisibility()"><!--*ngIf="checkEventVisibility()"-->
    <div class="container">
  <section id="banner" class="banner" *ngIf="event.image">
    <div class="banner-notify" *ngIf="isDraft()">{{'front_event.your_event_is_in_draft_mode_it_is_visible_only_by_you'| translate}}</div>
    <img src="{{event.image|assetimage}}" onError="this.src='assets/imgs/banner.png'" alt="{{event.name}}" class="event-detail-banner-img">
  </section>

  <section id="banner1" *ngIf="!event.image">
    <div class="banner-img-wrapper flexible">
      <img src="assets/imgs/banner.png"  alt="Bannière de l'évènement mis en avant" class="width-100 height-100">
    </div>
  </section>
    </div>

  <section *ngIf="isEnd" class="mt-3">
    <div class="container">
      <div class="alert alert-warning" role="alert"><strong>{{'front_event.Attention'| translate}}</strong>, {{'front_event.this_event_is_end'| translate}}</div>
    </div>
  </section>
  <!-- Event details -->
  <section id="event-details">
    <div class="container">
      <div class="row ">
        <div class="col-xs-12 col-lg-7">
          <div class="row">
            <div class="col-md-12">
              <header class="section-header">
                <h2 class="inline-block evt-date evt-date-size">{{buildDate()}}</h2>
                <h4 class="inline-block evt-time">
                  <i class="fa fa-clock-o"></i>
                  {{ event.start_hour| hourpipe }}
                </h4>
                <h1 class="evt-name-size">{{event.name}}</h1>

                <div *ngIf="!event.has_open_ticketing">
                  <div *ngIf="!eventIsOnline(event) && !eventNotHaveLocation(event)">
                   <h5 class="evt-place ">
                      <i class="fa fa-map-marker event-icon-marker"></i>
                       {{event.location_name}}
                   </h5>
                    <h5 class="evt-place inline-block"> {{location()}}</h5>
                  </div>
                  <div *ngIf="eventIsOnline(event)">
                    <h5>
                      <img src="../../../assets/imgs/icon-web.png" alt="icon-web" style="width: 30px;height: 30px">
                      <a href="{{'http://'+event.onlineLink}}" target="_blank">{{event.onlineLink}}</a>
                    </h5>
                  </div>
                </div>
              </header>
              <div class="section-content">
                <div class="evt-desc-wrapper" id="readMore-target">
                 <!-- {{event.desc}}-->
                  <p *ngIf="readMore" class="shawoded margin-top-10" [innerHTML]="sanitizeHtml(event.desc)"></p>

                  <p *ngIf="!readMore" class="margin-top-10"  style="max-height: 2000px" [innerHTML]="sanitizeHtml(event.desc)"></p>

                  <a href="javascript:void(0);" title="Lire la suite" class="inline-block text-uppercase readMore" (click)="readMore=!readMore" *ngIf="readMore==true">
                    <i class="fa fa-arrow-down"></i>
                    {{'front_event.read_more'| translate}}
                  </a>

                  <a href="javascript:void(0);" title="Lire la suite" class="inline-block text-uppercase readMore" (click)="readMore=!readMore" *ngIf="readMore==false">
                    <i class="fa fa-arrow-up"></i>
                    {{'front_event.read_less'| translate}}
                  </a>
                </div>

                <section id="parevents" *ngIf="event.parent">
                  <a [routerLink]="['/event/' , slugify(event.parent.name), event.parent.id ]">
                  <div class="card-header" style="margin-bottom: 13px;">
                    <header class="text-uppercase" >{{'front_event.this_event_belong_to_an_event_group'| translate}}</header>
                  </div>
                  </a>
                </section>

                <section id="chilevents" *ngIf="event.children.length>0 && event.isParent">
                  <div class="card-header" style="margin-bottom: 13px;">

                    <header class="text-uppercase" *ngIf="event.children.length>0 && event.isParent">{{'front_event.ths_event_contains_other_events'| translate}}</header>
                  </div>
                 <div class="row">
                  <div class=" col-md-6 col-sm-6" *ngFor="let ev of event.children">
                    <div class="">
                      <a  [routerLink]="['/eventchild/' , slugify(ev.name), ev.id ]" class="inline-block"><!--[routerLink]="['/event/' , event.id ]"-->
                        <div class="evt-img-wrapper event-thumbox  text-center">
                          <div *ngIf="ev.thumbnail" >
                            <img src="{{ ev.thumbnail|assetimage }}"  onError="this.src='assets/imgs/banner.png'"  width="100%" height="50%" alt="Image de l'évènement" class="event-thumb-detail">
                          </div>
                          <div *ngIf="!ev.thumbnail">
                            <img src="{{ ev.image|assetimage }}" onError="this.src='assets/imgs/banner.png'"  *ngIf="ev.image" alt="Image de l'évènement" class="height-100">
                            <img src="assets/imgs/banner.png" *ngIf="!ev.image" onError="this.src='assets/imgs/banner.png'"  alt="Image de l'évènement" class="height-100">
                          </div>
                          <!-- <ng-template *ngIf="!event.thumbnail" #banner_content>
                            <img src="{{ event.image|assetimage }}" alt="Image de l'évènement" class="height-100">

                           </ng-template>-->
                        </div>

                        <div class="flexcontainer  space-between">
                        <div >
                          <div class="flexcontainer flex-row space-between" style="width: 247px;" >
                            <h6 class="evt-date">  {{ev.start_date | datefrench}}</h6>
                            <h6 class=" evt-time-detail">
                              <i class=" fa fa-clock-o"></i>
                              {{ev.start_hour| hourpipe }}
                              <!-- {{ event.timezone }}-->
                            </h6>

                          </div>

                          <h5 class="block evt-place" style="font-size: 17px;">{{ev.name}}</h5>

                          <h6 class="block evt-location-details" style="font-size: 12px;color: #212529;margin-right: 30px">
                            <i class="fa fa-map-marker"></i>
                            {{ev.location_name}}
                          </h6>
                        </div>

                        </div>
                        <div class="" style="text-align: right;margin-top: -12px;">
                          <a [routerLink]="['/eventchild/' , slugify(ev.name), ev.id ]" title="{{ getTicketingType(event).title | translate  }}" class="btn btn-style children {{ getTicketingType(event).class }}"  >{{ getTicketingType(event).label| translate }}</a>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                </section>

                <section id="eventVideo" *ngIf="event.videoSrc">
                  <div class="card-header" style="margin-bottom: 13px;">

                    <header class="text-uppercase" *ngIf="event.videoSrc">{{'front_event.video'| translate}}</header>
                  </div>
                  <div class="row">
                    <iframe allowfullscreen width="600" height="315"
                            [attr.src]="event.videoSrc | safe">
                    </iframe>
                  </div>
                </section>
                <!-- images-->
                <section id="eventPhotos" *ngIf="galery && galery.length > 0" style="text-align: center!important;">
                  <div class="card-header" style="margin-bottom: 13px;">
                    <header class="text-uppercase" >{{'front_event.gallery'| translate}}</header>
                  </div>
                  <div class="col-xs-12 gallery-wrapper flexible" style="align-items: center;justify-content: center;">
                    <b *ngIf="!(galery || galery.length > 0)" >{{'front_event.no_picture_available'| translate}}</b>
                    <div id="gallery-carousel" class="carousel slide prevent-carousel-remove" data-ride="carousel" style="text-align: center!important;">
                      <ol class="carousel-indicators" >
                        <li *ngFor="let photo of galery; let idx = index" data-target="#gallery-carousel" [attr.dataSlideTo]="idx" class="{{ idx == 0 ? 'active' : ''}}"></li>
                      </ol>
                      <div class="carousel-inner prevent-carousel-remove" role="listbox" style="text-align: center!important;">
                        <div *ngFor="let photo of galery; let idx = index" class="carousel-item prevent-carousel-remove {{ idx == 0?'active':'' }}" >
                          <div class="width-100" style="text-align: center">
                            <img src="{{ photo|assetimage }}" onError="this.src='assets/imgs/banner.png'" style="max-height: 400px;min-height:400px;margin:0 auto" *ngIf="photo" alt="" class="img-fluid">
                          </div>
                        </div>
                      </div>
                      <a class="carousel-control-prev" href="#gallery-carousel" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">{{'front_event.previous'| translate}}</span>
                      </a>
                      <a class="carousel-control-next" href="#gallery-carousel" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">{{'front_event.next'| translate}}</span>
                      </a>
                    </div>
                  </div>
                </section>

                <section id="eventMap" *ngIf="positions && !eventIsOnline(event) && hasLocation() && !event.has_open_ticketing" style="margin-top: 7px">
                  <div class="card-header" style="margin-bottom: 13px;">
                    <header class="text-uppercase" *ngIf="positions">{{'front_event.map'| translate}}</header>
                  </div>
                  <div>
                    <div *ngFor="let pos of positions">
                      <agm-map [zoom]="12" [latitude]="pos.lat" [longitude]="pos.lng">
                        <agm-marker  style="font-weight: bold;" [openInfoWindow]="" [latitude]="pos.lat" [longitude]="pos.lng">
                          <agm-info-window [isOpen]="true" ><span  style="font-size: 14px;font-weight: bold">{{this.event.adresse}}</span><br>{{location1()}}</agm-info-window>
                        </agm-marker>
                      </agm-map>
                    </div>
                  </div>
                </section>
                <section *ngIf="event.faqs?.length > 0" class="mt-35p">
                  <h3>Questions fréquentes</h3>

                  <div class="panel panel-default other-panel faq-b-b" *ngFor="let faq of event.faqs;let idx = index">
                    <div class="panel-heading pd-0-15p">
                       <button data-toggle="collapse" class="accordion-toggle faq-question-color font-size-20 toggle-faq TitilliumWeb-Regular" [attr.data-target]="'#collapse'+idx" >
                         {{faq.question}}
                       </button>
                    </div>
                    <div class="panel-body">
                      <div id="collapse{{idx}}" class="collapse font-size-20 TitilliumWeb-Regular pd-0-15-15p">
                        {{faq.answer}}
                      </div>
                    </div>
                  </div>
                </section>
               <!-- <section>

                  <ul class="nav nav-tabs">
                    <li (click)="showMessages = !showMessages" class="{{!showMessages?'active':''}} width-49 mr-2"><a class="inline-block pd-5 width-100" data-toggle="tab" href="#tab1">Donateurs</a></li>
                    <li (click)="showMessages = !showMessages" class="{{showMessages?'active':''}} width-49"><a class="inline-block pd-5 width-100" data-toggle="tab" href="#tab2">Messages</a></li>
                  </ul>

                  <div class="tab-content">
                    <div id="tab1" class="tab-pane fade in active show">
                      <h3>Tab 1</h3>
                      <p>Content for tab 1.</p>
                    </div>
                    <div id="tab2" class="tab-pane fade">
                      <h3>Tab 2</h3>
                      <p>Content for tab 2.</p>
                    </div>
                  </div>
                </section>-->
              </div>
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-lg-5" id="reservation-wrapper">
          <div class="card" *ngIf="isEnd">
            <div class="card-header">
              <header>{{'front_event.closed'| translate}}</header>
            </div>
            <div class="card-body p-2">
              {{'front_event.this_event_is_end'| translate}}
            </div>
          </div>
          <!--<div class="card" *ngIf="!isEnd && event.has_ticketing=='0' && event.has_open_ticketing=='0'  ">
            <div class="card-header">
              <header>{{'front_event.no_booking'| translate}}</header>
            </div>
            <div class="card-body p-2">
              {{'front_event.this_event_has_no_ticketing'| translate}}
            </div>
          </div>-->
          <!-- TODO #MEDIUM prevoir un affichage qd toutes les places completes -->
          <div class="card" *ngIf="!isEnd && event_has_Booking(event) && isClosed">
            <div class="card-header">
              <header> {{'front_event.booking_is_end'| translate}}</header>
            </div>
            <div class="card-body p-2">
              {{'front_event.it_is_no_longer_possible_to_book_this_event'| translate}}
            </div>
          </div>
          <div class="card event-reservation" [ngClass]="isDraftCls()" *ngIf="!isEnd && event_has_Booking(event) && !isClosed">
            <div class="card-header">
              <header *ngIf="!eventIsjackpot(event)">{{'front_event.book'| translate}}</header>
              <header *ngIf="eventIsjackpot(event)">{{'front_event.participate'| translate}}</header>
            </div>
            <div class="card-body">
              <div class="counter-wrapper" *ngIf="!countdownStoped && !event.has_open_ticketing">
                <ul id="counter" class="flexible">
                  <li>
                <input type="text" disabled name="days" value="{{diffdays}}">
                    <label  class="text-uppercase">{{'front_event.days'| translate}}</label>
                  </li>
                  <li>
                   <!-- <countdown [text]="text" units="Hours"  end="July 22, 2019"></countdown>-->
                   <input type="text" disabled name="hours" value="{{diffhour}}">
                    <label  class="text-uppercase">{{'front_event.hours'| translate}}</label>
                  </li>
                  <li>
                  <!--  <countdown [text]="text" units="Minutes"  end="July 22, 2019"></countdown>-->
                    <input type="text" disabled name="minutes" value="{{diffminutes}}">
                    <label  class="text-uppercase">{{'front_event.minutes'| translate}}</label>
                  </li>
                </ul>
              </div>

              <div *ngIf="event_has_Booking(event)" style="text-align: center!important;">

              <div *ngIf="event.has_open_ticketing && !startJackpot" class="center">
                <div class="center " style="margin-bottom: 2px;margin-top: 10px">
                  <div class="bold fontsize-40 line-heih-38" style="margin-bottom: 5px">{{showValue(event.objectiveState) +' '+functionUtils.getPricingDeviseSymbole(event.currency)}}</div>

                  <span class="text-uppercase bold" *ngIf="event.showObjective">{{'front_event.COLLECTED_ON'| translate}} {{showValue(event.objective) +' '+functionUtils.getPricingDeviseSymbole(event.currency) }}</span>
                  <span class="text-uppercase bold" *ngIf="!event.showObjective">{{'front_event.collected'| translate}}</span>

                </div>
                 <div class="progress progress-custom"  *ngIf="event.showObjective == 1">
                   <div class="progress-bar" [ngStyle]="{'width': objectiveRate + '%'}" role="progressbar"  attr.aria-valuenow="{{objectiveRate}}" aria-valuemin="0" aria-valuemax="100"></div>
                 </div>

                <div class="flexible space-between pading-responsive-left-22-right-28" style="margin-top: 15px">

                  <div class="">
                    <span  class="font-size-20 center">  <i class="fa fa-clock-o" aria-hidden="true"></i>{{jackpotdaysremain}}<br>
                    <span>
                      {{'front_event.Remaining_days'| translate}}
                    </span>
                    </span>
                  </div>

                  <div class="margin-left-41-responsive">
                    <span class="font-size-20 center">
                    {{event.orders.length}} <i class="fa fa-user"></i> <br> Participations
                   </span>
                  </div>

                </div>
              </div>

            <ng-container *ngIf="!event.has_open_ticketing || startJackpot">


              <div *ngFor="let group of pricingGroups">
               <div *ngIf="group.pricings.length">
                <a style="display: inline-block" attr.aria-expanded="{{group.is_open?'true':'false'}}" data-toggle="collapse"  href="#collapse{{group.id}}" class="classCollapse" >{{group.label}}</a>

                <div class="collapse bg-white {{group.is_open?'show pricing-group-is-open':''}}"  id="collapse{{group.id}}">
                  <div  *ngFor="let pricing of group.pricings" >
                   <div class={{checkExhausted(pricing)}}>
                     <app-pricing-header [pricing]="pricing" [front_event]="front_event"></app-pricing-header>
                      <div   class="price-wrapper" [ngClass]="{'alert alert-danger': (pricing.Totalplace < pricing.nbreTicket)&& (pricing.Totalplace != -1)}">
                      <!--pas de cagnote ,normal-->
                          <span  class="price {{pricing.codePromo?'linet':''}}" *ngIf="!pricing.open">{{price(getPricingPrice(pricing))}}</span>
                          <span  class="price " *ngIf="pricing.codePromo">{{ price(calculatePricingPriceAfterPromoApply(pricing))}}</span>

                          <!--si cagnote-->
                      <!--  [ngClass]="{'alert alert-danger': (getPricingPrice(pricing)<1)}"-->

                        <span class="{{event.currency === 'USD'?'input-symbol-dollar':'input-symbol-euro'}} input-symbol-currency" *ngIf="pricing.open">
                          <input  *ngIf="pricing.open && !pricing.IsClosed"  (change)="changeListener($event,pricingsAndPrincingsInGroup)" min="1" style="display: inline-block" class="form-control pricing-selection" [(ngModel)]="pricing.price"  type="number">
                        </span>

                        <select class="pricing-selection {{pricing.open?'hide':''}} " *ngIf="!(pricing.Totalplace <= 0 && pricing.Totalplace != -1 && pricing.ShowNbPlace) && !pricing.IsComing && !pricing.IsClosed" type="number" [(ngModel)]="pricing.nbreTicket" value="{{pricing.nbreTicket}}" min="0"  (change)="changeListener($event,pricingsAndPrincingsInGroup)" name="nbreTicket" >

                          <ng-container *ngIf="!pricing.selectable_q">
                           <option  *ngFor = 'let item of nbTicketArray' value="{{ item }}" >{{ item}}</option>
                          </ng-container>

                          <ng-container *ngIf="pricing.selectable_q">
                            <option  *ngFor = 'let item of  pricing.pricingSelectableArray' value="{{ item }}" >{{ item}}</option>
                          </ng-container>

                        </select>

                        <app-pricing-statut [pricing]="pricing"></app-pricing-statut>
                      </div>
                  </div>
                    <div class="pricing-desc collapse" id="collapse{{pricing.id}}">
                      <span>{{nbPlace(pricing)}}</span> <br>
                      <span [innerHTML]="pricing.description">{{pricing.description}}</span>
                    </div>
                </div>
               </div>
              </div>
              </div>

              <div  *ngFor="let pricing of pricings">
               <div class="{{checkExhausted(pricing )}} {{pricing.open?'block-important':''}} {{pricing.open?'pading-0':''}}" style="padding-bottom: 1px!important;">

                <app-pricing-header class="{{pricing.open?'hide':''}}" [pricing]="pricing" [front_event]="front_event"></app-pricing-header>

                 <!--si cagnote-->
                 <div *ngIf="pricing.open">
                 <div class="{{pricing.open?'block-important':'hide'}} center" style="font-size: 19px">
                   <span>  {{'front_event.Choose_the_amount_of_your_participation'| translate}} </span>
                 </div>
                 <div class="center" style="margin-bottom: 15px;margin-top: 40px">
                   <div *ngFor = 'let item of openPricePurpose' class="inline-block">
                     <div *ngIf="item.value" class="pricing-purpose-class {{item.active?'purpose-active':''}} pointer-t" (click)="purposeOpenprice(item,pricing)"><span> {{item.value}}</span></div>
                   </div>
                 </div>
                 </div>

                 <div class="block-important center">
                  <!-- "-->
                     <span class="{{event.currency=='USD'?'input-symbol-dollar':'input-symbol-euro'}} input-symbol-currency" *ngIf="pricing.open">
                         <input  *ngIf="pricing.open && !pricing.IsClosed" placeholder="montant libre"  style="display: inline-block" (change)="changeopenPricingsListener($event,pricingsAndPrincingsInGroup)" class="form-control pricing-selection width-80" [(ngModel)]="pricing.price" value="{{pricing.price}}" type="number">
                     </span>
                 </div>

                <div class="price-wrapper" [ngClass]="{'alert alert-danger': pricingIsToMuchSelected(pricing)}">
                  <!--pas de cagnote ,normal-->
                  <span class="price {{pricing.codePromo?'linet':''}}" *ngIf="!pricing.open">{{price(getPricingPrice(pricing))}}</span>

                  <span class="price" *ngIf="pricing.codePromo">{{price(calculatePricingPriceAfterPromoApply(pricing))}}</span>

                  <select class="pricing-selection {{pricing.open?'hide':''}} " *ngIf="!(pricing.Totalplace <= 0 && pricing.Totalplace != -1 && pricing.ShowNbPlace) && !pricing.IsComing && !pricing.IsClosed" type="number" [(ngModel)]="pricing.nbreTicket" value="{{pricing.nbreTicket}}" min="0"  (change)="changeListener($event,pricingsAndPrincingsInGroup)" name="nbreTicket" >

                        <ng-container *ngIf="!pricing.selectable_q">
                          <option  *ngFor = 'let item of nbTicketArray' value="{{ item }}" >{{ item}}</option>
                        </ng-container>

                        <ng-container *ngIf="pricing.selectable_q">
                          <option  *ngFor = 'let item of  pricing.pricingSelectableArray' value="{{ item }}" >{{ item}}</option>
                        </ng-container>

                  </select>

                  <app-pricing-statut [pricing]="pricing"></app-pricing-statut>
                </div>
              </div>
                <div class="pricing-desc collapse" id="collapse{{pricing.id}}">
                  <span>{{nbPlace(pricing)}}</span> <br>
                  <span [innerHTML]="pricing.description">{{pricing.description}}</span>
                </div>
              </div>

                <div style="margin-top: 15px" class="alert alert-success flexible space-between" *ngFor="let code of codePromosActivated">
                  <div class="m-auto">
                  <div>
                    <span>
                   {{'code promo : '}}{{'front_event.activated'| translate}}
                  <!-- <i class="fa fa-arrow-right"></i>-->
                      <br>
                   <span *ngIf="code.pricing">{{code.pricing.label}}</span>
                   <span *ngIf="code.reduction_simple"> {{'- '+code.reduction_simple+' '+functionUtils.getPricingDeviseSymbole(event.currency)+' TTC'}}</span></span>
                   <span *ngIf="code.reduction_by_percentage"> {{'- '+code.reduction_by_percentage+' %'}}</span>
                    <span *ngIf="code.reduction_type == 'Gratuit'"> Gratuit</span>
                  </div>
                  <span class="pointer1 horver_underline" (click)="deleteCodePRomo(code)">{{'front_event.delete'| translate}}</span>
                  </div>
                </div>

                <div class="price-total"  *ngIf="event_has_Booking(event) && pricings">
                  {{'front_event.total'| translate}}: <span class="price ">{{Total.toFixed(2) +' '+functionUtils.getPricingDeviseSymbole(devise)}}</span>
                </div>

                <div class="code-promo" *ngIf="!hasCodePromoClicked && event.codes.length > 0">
                  {{'front_event.you_have_reduction_code'| translate}}: <span class="click-here pointer1" (click)="changeHasCodePromo()">{{'front_event.click_here'| translate}}</span>
                </div>

                <div class="code-promo" *ngIf="hasCodePromoClicked">
                  <input class="form-control col-md-6 inline-block" [(ngModel)]="codePrmo"  placeholder="{{'front_event.enter_your_code'| translate}}"  type="text">  <span class="apply-code-btn pointer1" (click)="applycodePromo()">{{'front_event.apply'| translate}}</span>
                </div>

            </ng-container>
                </div>
              </div>
              <div class="card-footer" *ngIf="event_has_Booking(event) && pricings">
              <a   title="Poursuivre" href="javascript:void(0);" (click)="poursuivre(pricings)" id="validateCmd" class="inline-block text-uppercase">
                {{'front_event.continue'| translate}}
                <i class="fa fa-arrow-circle-o-right"></i>
              </a>
              <div class="payment-icons">
                <div class="payment-icon__left">
                  <ul class="payment-icons__list list-inline">
                    <li class="list-inline-item">
                      <img src="assets/imgs/payment/visa.png" class="img-fluid" width="70" alt="..."/>
                    </li>
                    <li class="list-inline-item">
                      <img src="assets/imgs/payment/mastercard.png" class="img-fluid" width="70" alt="..."/>
                    </li>
                  </ul>
                </div>
                <div class="payment-icon__right">
                  <img src="assets/imgs/payment/badge_secu.png" class="img-fluid" width="125" alt="..."/>
                </div>
              </div>
            </div>
          </div>

          <div class="card card-mini" *ngIf="event.PlanSrc">

            <div class="card-header header-background ">
              <header class="text-uppercase header-paddingLeft">{{'front_event.seating_plan'| translate}}</header>
            </div>

            <div class="card-border" style="cursor: pointer" (click)="planExtension()">
              <img [src]="event.PlanSrc | assetimage" width="500" height="300" alt="">
            </div>

            <div class="card-header header-background ">
              <header class="text-uppercase header-paddingLeft">{{event.PlanName}}</header>
            </div>

          </div>

          <div class="card card-mini">

            <div class="card-header header-background">
              <header class="text-uppercase header-paddingLeft">{{'front_event.make_know'| translate}}</header>
            </div>

            <div class="card-body card-border">
              <ul class="social-nets flexible compact-children-margin content-center">

                <li style="overflow: unset!important;">
                  <!--<a href="javascript:void(0)" shareButton="facebook" title="Facebook">
                    <img src="assets/imgs/facebook.png" alt="Logo facebook">
                  </a>
                   -->
                  <button
                    style="background-color: unset!important;"
                    shareButton="facebook"
                    id="facebookShare"
                    [title]="event.name"
                    [url]="url"
                    [description]="event.description"
                    [image]="event.thumbnail|assetimage"
                    #fbBtn="shareButton">
                    <img style="height: 47px;margin-left: -5px;" src="assets/imgs/facebook.png" alt="Logo facebook">
                  </button>
                </li>

                <li style="overflow: unset!important;">
                  <button
                    style="background-color: unset!important;"
                    shareButton="twitter"
                    id="twitterShare"
                    [title]="event.name"
                    [url]="url"
                    [description]="event.description"
                    [image]="event.thumbnail|assetimage"
                    #fbBtn="shareButton">
                    <img style="height: 47px;margin-left: -5px;" src="assets/imgs/twitter.png" alt="Logo twitter">
                  </button>
                </li>

                <li id="logo-whatsapp-wrapper" style="overflow: unset!important;">
                  <button
                    style="background-color: unset!important;"
                    shareButton="whatsApp"
                    id="whatsappShare"
                    [title]="event.name"
                    [url]="url"
                    [description]="event.description"
                    [image]="event.thumbnail|assetimage"
                    #fbBtn="shareButton">
                    <img style="height: 47px;margin-left: -5px;" src="assets/imgs/whatsapp.png" alt="Logo WhatsApp">
                  </button>
                 <!--
                  <a href="javascript:void(0)" shareButton="whatsApp" data-action="share/whatsapp/share" title="WhatsApp">
                    <img src="assets/imgs/whatsapp.png" alt="Logo WhatsApp">
                  </a>-->
                </li>

                <li id="logo-facebookmessenger-wrapper" style="overflow: unset!important;">
                  <button
                    style="background-color: unset!important;"
                    shareButton="messenger"
                    id="messengerShare"
                    [title]="event.name"
                    [url]="url"
                    [description]="event.description"
                    [image]="event.thumbnail|assetimage"
                    #fbBtn="shareButton">
                    <img style="height: 47px;margin-left: -5px;" src="assets/imgs/messenger.png" alt="Logo Messenger">
                  </button>
                 <!-- <a href="fb-messenger://share?link={{buildLink()}}" title="Facebook Messenger">
                    <img src="assets/imgs/messenger.png" alt="Logo Messenger">
                  </a>-->
                </li>

                <li *ngIf="!copyDisabled">
                  <a href="#" (click)="copyLink()" clip="The word you want to copy" (onClip)="callback($event)" title="{{'front_event.share_the_event_link'| translate}}">
                    <img src="assets/imgs/link.png" alt="{{'front_event.share_the_event_link'| translate}}">
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="card card-mini">
            <div class="card-header header-background ">
              <header class="text-uppercase header-paddingLeft">{{'front_event.organizer'| translate}}</header>
            </div>
            <div class="card-body card-border" (click)="openContactModal()" style="cursor: pointer;padding-left: 10px">
              <div class="user-card flexible">
                <span class="img-wrapper" *ngIf="!organisaion || !(organisaion && organisaion.logo)"><img src="assets/imgs/avatar.png"  alt="Avatar de l'organisateur"></span>

                <span class="img-wrapper" *ngIf="organisaion && organisaion.logo"><img [src]="organisaion.logo|assetimage"  alt="Avatar de l'organisateur"></span>
                <div style="margin-left: 10px;">
                    <header  *ngIf="!organisaion" class="text-uppercase">{{'front_event.organizer'| translate}} {{event.user.id}}</header>
                    <header  *ngIf="organisaion" class="text-uppercase">{{organisaion.name}}</header>
                     <div style="margin-top: 10px">
                         <a type="button" (click)="openContactModal()" class="width-250 btnColor backgroundWhite center contacts-btns"> <i class="fa fa-envelope blackColor"></i> {{'front_event.contact_the_organizer'| translate}}</a>
                     </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card card-mini">
            <div class="card-header header-background ">
              <header class="text-uppercase header-paddingLeft">{{'front_event.support'| translate}}</header>
            </div>
            <div class="card-body card-border " style="cursor: pointer">
              <div class="user-card flexible content-center">
                 <div style="font-size: 20px">{{'front_event.a_problem_with_your_order_'| translate}}</div>
              </div>
              <div class="flexible content-center" style="margin-top: 26px">
                <a type="button" [routerLink]="['/contact']" class="width-250 btnColor backgroundWhite center contacts-btns"> <i class="fa fa-envelope blackColor"></i> {{'front_event.contact_our_support'| translate}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  </div>

   </div>
  </div>
